module.exports = __webpack_public_path__ + "img/qr-scan-hand.d20e4163.webp";